/* eslint-disable */
import 'jquery';
import 'jquery.scrollto';

const resources = (function() {

  // Lib
  const cloneDeep = require('lodash/cloneDeep');

  // Vars
  let state = {
    articles: [],
    filters: {
      topics: [],
      types: [],
      search: '',
    },
    filteredArticles: [],
    render: [],
    pagination: {
      perPage: 10,
      pages: 0,
      current: 0,
      navToShow: 5,
      firstRun: 0,
    },
  };


  // Initialize resources
  const init = function() {
    // Exit if not on the resources page
    if ( !$('body').hasClass('post-type-archive-article') ) { return; }

    // Fetch resources from the cache to kick things off
    const url = window.location.origin + '/wp-content/plugins/nif-resource-cache/resources.json';
    // Use ajax instead of fetch (this version of Sage cannot support async/await)
    $.ajax( url )
    .done(function( data ) {
      // We fetched articles, set data to state and perform the first render
      state.articles = data;
      state.filteredArticles = data;
      initRender({
        firstRun: true
      });
    })
    .fail(function( err ) {
      console.error( 'resources.js: jQuery ajax error' );
      console.error( err );
    });

    // Watch for URL hash changes (if the user clicks a main navigation link
    // with a URL hash for this page, we want to apply the hash to the filters
    // and then scroll the user to the resources section)
    window.addEventListener('hashchange', () => {
      applyUrlHash();
      initRender();
      $(window).scrollTo('.resources-content', 500, { easing:'swing' });
    });

    //
    // Setup interactivity
    //

    // Pagination click handler
    $('body').on('click', '.resources-pagination a', function() {
      initRender({
        page: parseInt( $(this).attr('data-index') ),
        hash: true
      });
      $(window).scrollTo('.resources-content', 500, { easing:'swing' });
    });
    $('body').on('keydown', '.resources-pagination a', function(e) {
      if ( e.code === 'Enter' || e.code === 'Space' ) {
        e.preventDefault(); // Prevent the page from scrolling if user presses 'space'
        initRender({
          page: parseInt( $(this).attr('data-index') ),
          hash: true
        });
        $(window).scrollTo('.resources-content', 500, { easing:'swing' });
      }
    });

    // Filter change handler
    $('input[data-filter]').on('change paste keyup', function() {
      initRender({ hash: true });
    });

    // Filter expand/collapse handler
    $('a.resources-sidebar__filter-title').on('click', function() {
      expandFilter( $(this).closest('.resources-sidebar__filter') );
    });
    $('a.resources-sidebar__filter-title').on('keydown', function(e) {
      if ( e.code === 'Enter' || e.code === 'Space' ) {
        e.preventDefault();
        expandFilter( $(this).closest('.resources-sidebar__filter') );
      }
    });

    // Child flter expand/collapse handler
    $('.resources-sidebar__filter-item a.resources-sidebar__chevron').on('click', function() {
      expandChildFilter( $(this).closest('.resources-sidebar__filter-item') );
    });
    $('.resources-sidebar__filter-item a.resources-sidebar__chevron').on('keydown', function(e) {
      if ( e.code === 'Enter' || e.code === 'Space' ) {
        e.preventDefault();
        expandChildFilter( $(this).closest('.resources-sidebar__filter-item') );
      }
    });

    // Clear filters link handler
    $('.resources-sidebar__clear').on('click', function() {
      clearFilters(); // empty the search / uncheck checkboxes
      initRender({ hash: true }); // init the render again!
    });
    $('.resources-sidebar__clear').on('keydown', function(e) {
      if ( e.code === 'Enter' || e.code === 'Space' ) {
        e.preventDefault();
        clearFilters(); // empty the search / uncheck checkboxes
        initRender({ hash: true }); // init the render again!
      }
    });
  };

  //
  //  RENDERING
  //

  /**
   * Initialize Render
   *
   * This function kicks off rendering and calls many subroutines in support of
   * rendering. Ultimately it applies filtering to articles, sets pagination,
   * fetches a list of filtered articles to be rendered, performs URL hashing,
   * and calls the render() function with does the actual DOM population.
   *
   * @param {object} data Accepts various params
   * @param {boolean} data.firstRun Was this called on page load?
   * @param {number} data.page Provide an index for the page of results to show
   * @param {boolean} data.hash Should URL hashing be performed?
   */
  const initRender = function( data = {} ) {
    // Setup initial data state with default parameters
    if ( typeof data.firstRun === 'undefined' ) {
      data.firstRun === false;
    }
    if ( typeof data.page === 'undefined' ) {
      data.page = 0;
    }
    if ( typeof data.hash === 'undefined' ) {
      data.hash = false;
    }

    // Clear the current render in state so we don't show old posts
    state.render = [];

    // First, update our state so that we can render the right posts.

    // If this is our first run, check for a URL hash and apply it to
    // matching DOM elements. We generate the filter state based on
    // which checkboxes are checked/what text is in the search field,
    // so this is data from the URL applies to filters.
    if ( data.firstRun ) { applyUrlHash(); }

    // Apply any selected filters to the state
    updateFilterState();

    // Apply `state.filters` on `state.articles`, set to `state.filteredArticles`
    filterArticles();

    // Set `state.pagination`
    state.pagination.pages = Math.ceil( state.filteredArticles.length / state.pagination.perPage );
    if ( data.firstRun ) {
      state.pagination.current = state.pagination.firstRun;
    } else {
      state.pagination.current = data.page;
    }

    // Hash the URL if the data.hash param was set to true
    if ( data.hash ) {
      hashUrl();
    }

    // Now that we've updated our state, add the actual posts to state.render

    // Select `state.render` posts from `filteredArticles` based on
    // pagination values
    const start = state.pagination.current * state.pagination.perPage;
    const end = ( state.pagination.current * state.pagination.perPage ) + state.pagination.perPage;
    state.render = state.filteredArticles.slice( start, end );

    // Set the 'clear' filters link visiblity
    setClearFiltersVisibility();

    // If first run, ensure filters with selected checkboxes are visually
    // expanded (in case the user loads a window with a pre-hashed URL)
    if ( data.firstRun ) {
      conditionallyOpenFilters();
    }

    // Call rendering function to actually render things onto the page!
    render();
  };

  /**
   * Render
   *
   * This function generates the markup for resources and injects it
   * into the page.
   */
  const render = function() {
    let html = '';
    if ( state.render.length > 0 ) {
      html += generateViewingCount();
      for ( let i=0; i<state.render.length; i++ ) {
        html += generateArticleMarkup( state.render[i] );
      }
      html += generatePaginationMarkup();
    } else {
      html += '<div class="resources-error">';
        html += '<span class="resources-error__headline">No resources found</span>';
        html += '<p>Your query returned no resources. Please adjust your filters and try again.</p>'
      html += '</div>';
    }
    $('.resources-content').html( html );
  };

  /**
   * Generate Article Markup
   *
   * Accepts an article object and returns HTML for the article to `render()`
   *
   * @param {object} article The article to render
   * @returns {string} HTML string for the article
   */
  const generateArticleMarkup = function( article ) {
    let html = ``;
    html += `<article class="resource-article" id="resource-${ article.id }">`;
      html += `<div class="resource-article__text">`;
        html += `<span class="resource-article__display-term">${ article.display_term }</span>`;
        html += `<a class="resource-article__title" href="${ article.permalink }">${ article.title }</a>`;
        html += `<span class="resource-article__date">${ article.date }</span>`;
        if ( article.excerpt ) {
          html += `<span class="resource-article__excerpt">${ article.excerpt }</span>`;
        }
        if ( article.downloads ) {
          html += `<div class="resource-article__downloads">`;
            for ( let i=0; i<article.downloads.length; i++ ) {
              html += `<a href="${ article.downloads[i].url }" target="_blank" rel="noopener noreferrer">${ article.downloads[i].title }</a>`
            }
          html += `</div>`;
        }
      html += `</div> <!-- .resource-article__text -->`;
      if ( article.thumbnail ) {
        html += `<div class="resource-article__image">`;
          html += `<a href="${ article.permalink }">`;
            html += `<img src="${ article.thumbnail.url }" alt="${ article.thumbnail.alt }" width="${ article.thumbnail.width }" height="${ article.thumbnail.height }"></div>`;
          html += `</a>`;
        html += `</div>`;
      }
    html += `</article>`
    return html;
  };

  /**
   * Generate Pagination Markup
   *
   * Generates and returns pagination HTML based on the values set
   * in `state.pagination`
   *
   * @returns {string} HTML string for pagination
   */
  const generatePaginationMarkup = function() {
    let html = '';

    if ( state.pagination.pages > 1 ) {
      html = '<ul class="resources-pagination">';

      // Small number of pages, no dots
      if ( state.pagination.pages <= state.pagination.navToShow ) {
        for ( let i=0; i<state.pagination.pages; i++ ) {
          if ( i === state.pagination.current ) {
            html += `<li><a class="current" data-index="${i}" tabindex="0">${i + 1}</a></li>`;
          } else {
            html += `<li><a data-index="${i}" tabindex="0">${i + 1}</a></li>`;
          }
        }
      }
      // Large number of pages, show dots
      else {
        // Start of list, eg. 1-3
        if ( state.pagination.current < state.pagination.navToShow - 2 ) {
          for ( let i=0; i<state.pagination.navToShow - 1; i++ ) {
            if ( i === state.pagination.current ) {
              html += `<li><a class="current" data-index="${i}" tabindex="0">${i + 1}</a></li>`;
            } else {
              html += `<li><a data-index="${i}" tabindex="0">${i + 1}</a></li>`;
            }
          }
          html += '<li><span class="dots">&hellip;</span></li>';
          html += `<li><a data-index="${state.pagination.pages - 1}" tabindex="0">${state.pagination.pages}</a></li>`;
        }
        // Middle of list, eg. 4-97
        if ( state.pagination.current >= state.pagination.navToShow - 2 && state.pagination.current < state.pagination.pages - ( state.pagination.navToShow - 2 ) ) {
          html += `<li><a data-index="${0}" tabindex="0">${1}</a></li>`;
          html += '<li><span class="dots">&hellip;</span></li>';
          let offset = Math.floor( state.pagination.navToShow / 2 );
          for ( let i = state.pagination.current - offset; i < state.pagination.current + ( offset + 1 ); i++ ) {
            if ( i === state.pagination.current ) {
              html += `<li><a class="current" data-index="${i}" tabindex="0">${i + 1}</a></li>`;
            } else {
              html += `<li><a data-index="${i}" tabindex="0">${i + 1}</a></li>`;
            }
          }
          html += '<li><span class="dots">&hellip;</span></li>';
          html += `<li><a data-index="${state.pagination.pages - 1}" tabindex="0">${state.pagination.pages}</a></li>`;
        }
        // End of list, eg. 194-197
        if ( state.pagination.current >= state.pagination.pages - ( state.pagination.navToShow - 2 ) ) {
          html += `<li><a data-index="${0}" tabindex="0">${1}</a></li>`;
          html += '<li><span class="dots">&hellip;</span></li>';
          for ( let i = state.pagination.pages - ( state.pagination.navToShow - 1 ); i < state.pagination.pages; i++ ) {
            if ( i === state.pagination.current ) {
              html += `<li><a class="current" data-index="${i}" tabindex="0">${i + 1}</a></li>`;
            } else {
              html += `<li><a data-index="${i}" tabindex="0">${i + 1}</a></li>`;
            }
          }
        }
      }

      html += '</ul>';
    }

    return html;
  };

  /**
   * Generate Viewing Count
   *
   * Generates and returns a "Viewing X-Y of Z items" string to be
   * displayed before the list of resources based on the current state.
   *
   * @returns {string} HTML string
   */
  const generateViewingCount = function() {
    let html = '<span class="resources-content__viewing">Viewing ';
    html += state.pagination.current * state.pagination.perPage + 1;
    html += '–';
    html += ( state.pagination.current * state.pagination.perPage ) + state.render.length;
    html += ' of ' + state.filteredArticles.length + ' items';
    html += '</span>';
    return html;
  };

  //
  //  FILTERING
  //

  /**
   * Update Filter State
   *
   * This function looks at each filter element on the page (search input and
   * taxonomy checkboxes) and updates `state.filters` with the values it finds
   */
  const updateFilterState = function() {
    // Reset filter state to empty
    state.filters = {
      topics: [],
      types: [],
      search: '',
    };

    // Apply search filter to the state
    if ( $('input[data-filter][type=search]').val() ) {
      state.filters.search = $('input[data-filter][type=search]').val();
    }
    // Apply checkbox filters to state
    $('input[data-filter][type=checkbox]:checked').each(function(){
      const target = $(this).attr('data-filter');
      state.filters[target].push( $(this).val() );
    });
  };

  /**
   * Filter Articles
   *
   * This function creates a list of articles from `state.articles` that match
   * the selected filters and adds them to `state.filteredArticles`.
   */
  const filterArticles = function() {
    // Empty state.filteredArticles before we begin so we don't show any relics
    // from past filtering.
    state.filteredArticles = [];

    // Loop through state.articles and add those that match filters to the
    for ( let i=0; i<state.articles.length; i++ ) {
      // Make a deep clone (https://lodash.com/docs/#cloneDeep) of the
      // article object so that when we modify it (eg. highlighting a search
      // string in the title), we leave the original article object
      // unmolested and pristine.
      const article = cloneDeep( state.articles[i] );

      // Check if search string matches title
      if ( state.filters.search.length > 0 ) {
        const titleLower = article.title.toLowerCase();
        const searchLower = state.filters.search.toLocaleLowerCase();
        if ( titleLower.indexOf( searchLower ) === -1 ) {
          // Search string doesn't match title, do not include
          continue;
        } else {
          // Search string matches the title, wrap the sub-string with a span
          // to give it a highlight treatment
          article.title = highlightString( article.title, state.filters.search );
        }
      }

      // Check if topics match
      if ( state.filters.topics.length > 0 ) {
        // If article has no topics, do not include
        if ( article.terms.topics.length === 0 ) {
          continue;
        }
        // If article doesn't include all of our selected topics, do not include
        if ( !state.filters.topics.every( val => article.terms.topics.includes( val ) ) ) {
          continue;
        }
      }

      // Check if types match
      if ( state.filters.types.length > 0 ) {
        // If article has no types, do not include
        if ( article.terms.types.length === 0 ) {
          continue;
        }
        // If article doesn't include all of our selected types, do not include
        if ( !state.filters.types.every( val => article.terms.types.includes( val ) ) ) {
          continue;
        }
      }

      state.filteredArticles.push( article );
    }
  };

  /**
   * Clear Filters
   *
   * This function sets the actual filter elements' values back to their unfilled/
   * unchecked state.
   */
  const clearFilters = function() {
    $('.resources-sidebar__search').val('');
    $('input[data-filter]').prop('checked', false);
  };

  /**
   * Set "Clear" Filters Visibility
   *
   * This function checks to see if filtering has been performed, and sets the
   * "Clear" link's visibilty accordingly
   */
  const setClearFiltersVisibility = function() {
    if ( state.filters.search || state.filters.topics.length > 0 || state.filters.types.length > 0 ) {
      $('.resources-sidebar__clear').addClass('resources-sidebar__clear--visible').attr('tabindex', '0');

    } else {
      $('.resources-sidebar__clear').removeClass('resources-sidebar__clear--visible').attr('tabindex', '-1');;
    }
  };

  //
  //  URL HASHING
  //

  /**
   * Hash URL
   *
   * Creates and applies a URL hash for the selected filters and
   * pagination page.
   */
  const hashUrl = function() {
    // Create the hash
    let hash = '#';

    if ( state.filters.topics.length > 0 ) {
      hash += hash.length > 1 ? '&topics=' : 'topics=';
      for ( let i=0; i<state.filters.topics.length; i++ ) {
        hash += state.filters.topics[i];
        if ( i<state.filters.topics.length - 1 ) {
          hash += ',';
        }
      }
    }

    if ( state.filters.types.length > 0 ) {
      hash += hash.length > 1 ? '&types=' : 'types=';
      for ( let i=0; i<state.filters.types.length; i++ ) {
        hash += state.filters.types[i];
        if ( i<state.filters.types.length - 1 ) {
          hash += ',';
        }
      }
    }

    if ( state.filters.search ) {
      hash += hash.length > 1 ? '&search=' : 'search=';
      hash += state.filters.search;
    }

    if ( state.pagination.current > 0 ) {
      hash += hash.length > 1 ? '&page=' : 'page=';
      hash += ( state.pagination.current + 1 );
    }

    if ( hash.length > 1 ) {
      history.replaceState( null, '', hash );
    } else {
      history.replaceState( null, '', window.location.origin + window.location.pathname );
    }
  };

  /**
   * Apply URL Hash
   *
   * Called on page load, this function applies URL hash values. It applies
   * filter values by checking checkboxes or changing input values on the
   * actual DOM objects themselves, and `page` numbers are set to `state`
   */
  const applyUrlHash = function() {
    // Get the hash from the URL and break it down into an object
    const hash = window.location.hash.substring(1);
    const data = hash.split('&').reduce(function (res, item) {
      const parts = item.split( '=' );
      if ( parts[1] ) {
        if ( parts[0] === 'topics' || parts[0] === 'types' ) {
          res[ parts[0] ] = parts[1].split( ',' );
        } else {
          res[ parts[0] ] = parts[1];
        }
      }
      return res;
    }, {});

    // Reset all checkboxes and search fields
    $('input[data-filter]').prop('checked', false);
    $('input[data-filter][type=search]').val('');

    // Apply hashed data to elements on the page
    const keys = Object.keys( data );
    keys.forEach( ( key ) => {
      if ( typeof data[key] === 'object' ) {
        for ( let i=0; i<data[key].length; i++ ) {
          $( `input[data-filter="${key}"][value="${data[key][i]}"]` ).prop( 'checked', true );
        }
      }
      if ( key === 'search' ) {
        $(`input[data-filter="${key}"]`).val( data[key] );
      }
      if ( key === 'page' ) {
        state.pagination.firstRun = parseInt( data[key] ) - 1;
      }
    });
  };


  //
  //  FILTER EXPAND/COLLAPSE
  //

  /**
   * Expand Filter
   *
   * Performs a revealing animation for lists of checkbox filters.
   *
   * @param {jQuery object} $filter The filter elemnt to expand
   * @param {boolean} instant Should the filter open instantly (ie.
   *                          without any animation)?
   */
  const expandFilter = function( $filter, instant = false ) {
    if ( !$filter ) { return; }
    const $list = $filter.find('.resources-sidebar__filter-items');
    const $items = $filter.find('.resources-sidebar__filter-item');

    if ( $filter.attr('data-status') === 'closed' ) {
      // Open
      $filter.attr('data-status', 'open');
      $list.slideDown( instant ? 0 : 400 );
      let delay = instant ? 0 : 200;
      $items.each(function(){
        const $item = $(this);
        setTimeout(function(){
          $item.addClass('resources-sidebar__filter-item--visible');
        }, delay);
        delay += instant ? 0 : 50;
      });
    } else {
      // Close
      $filter.attr('data-status', 'closed');
      $list.slideUp(instant ? 0 : 400, function() {
        $items.removeClass('resources-sidebar__filter-item--visible');
      });
    }
  };

  /**
   * Expand Child Filter
   *
   * Performs a revealing animation for child lists within a filter.
   *
   * @param {jQuery object} $parent The parent element of the child to expand
   * @param {boolean} instant Should the filter open instantly (ie.
   *                          without any animation)?
   * @returns
   */
  const expandChildFilter = function( $parent, instant = false ) {
    if ( !$parent ) { return; }
    const $list = $parent.find('> ul.resources-sidebar__filter-item-children');
    const $items = $list.find('.resources-sidebar__filter-item-child');

    if ( $parent.attr('data-status') === 'closed' ) {
      // Open
      $parent.attr('data-status', 'open');
      $list.slideDown( instant ? 0 : 400);
      let delay = instant ? 0 : 200;
      $items.each(function(){
        const $item = $(this);
        setTimeout(function(){
          $item.addClass('resources-sidebar__filter-item-child--visible');
        }, delay);
        delay += instant ? 0 : 50;
      });
    } else {
      // Close
      $parent.attr('data-status', 'closed');
      $list.slideUp(instant ? 0 : 400, function() {
        $items.removeClass('resources-sidebar__filter-item-child--visible');
      });
    }
  };

  /**
   * Conditionally Open Filters
   *
   * Checks to see if a given filter contains checked items, and if so,
   * opens it. Called when a window is loaded with a URL hash.
   */
  const conditionallyOpenFilters = function() {
    $('.resources-sidebar__filter').each(function() {
      // Check if main filter should be open
      if ( $(this).find('input[type="checkbox"]:checked').length > 0 ) {
        expandFilter( $(this, true) );
      }
      // Check if parent items should be open
      const $childLists = $(this).find('.resources-sidebar__filter-item-children');
      $childLists.each(function() {
        if ( $(this).find('input[type="checkbox"]:checked').length > 0 ) {
          expandChildFilter( $(this).closest('.resources-sidebar__filter-item'), true );
        }
      });
    });
  };


  //
  //  Helpers
  //

  /**
   * Highlight String
   *
   * Highlights any instances of a given `serach` within a provided `str`
   *
   * @param {string} str The string of text to search within
   * @param {string} search The string we're trying to highlight
   * @returns {string} Original `str` with `search` wrapped in a <span>
   */
  const highlightString = function( str, search ) {
    const regex = new RegExp(search, 'gi');
    const replaced = str.replace(regex, (match) => {
      return `<span class="highlight">${match}</span>`;
    });

    return replaced;
  }

  return {
    init: init,
  }
})();

$(document).ready(function() {
  resources.init();
});
/* eslint-enable */



// WEBPACK FOOTER //
// ./scripts/components/resources.js